<!-- <div class="loading-shade" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
</div> -->

<div *ngIf="isAluno">
    <div class="header">
        <img src="../../../assets/logo-site.png" alt="Logo" class="logo">
        <span class="header-text">Olá {{aluno_}}</span>
        <button mat-button class="menu-button" (click)="isDesktop = !isDesktop">
            <mat-icon>menu</mat-icon>
        </button>

        <div class="menu" *ngIf="isDesktop">
            <ul>
                <li *ngFor="let item of menuItems">
                    <div (click)="linkSeletor(item.url,item.id)"
                        style="display: flex; justify-content: space-between; cursor: pointer;">
                        <img [src]="item.image" alt="{{ item.text }}">
                        <span>{{ item.text }}</span>
                    </div>
                </li>
            </ul>
        </div>

    </div>


    <div *ngIf="!isAluno">
        <div class="nome-unidade-curso">
            <mat-card-title class="aluno_curso">
                {{ cursoLocalStorage }}
            </mat-card-title>
            <mat-card-subtitle class="aluno_unidade">
                {{ unidadeLocalStorage }}
            </mat-card-subtitle>
        </div>


        <div class="grade-icones">
            <img class="imagem-fundo" src="../../../assets/fundo.png" alt="imagem-fundo">
            <mat-grid-list class="qwert" cols="4" rowHeight="49%">
                <mat-grid-tile>
                    <button mat-button class="botao-icone" (click)="gotoMinhasAulas()">
                        <img class="icone_grade" src="../../../assets/minhas_aulas2.png" alt="logo_minhas_aulas">
                        <p class="p-icone">Minhas Aulas</p>
                    </button>
                </mat-grid-tile>
                <mat-grid-tile>
                    <button mat-button class="botao-icone" (click)="gotoSimulados()">
                        <img class="icone_grade" src="../../../assets/simulados.png" alt="logo_simulados">
                        <p class="p-icone">Simulados</p>
                    </button>
                </mat-grid-tile>
                <mat-grid-tile>
                    <button mat-button class="botao-icone" (click)="goToFinaceiro()">
                        <img class="icone_grade" src="../../../assets/financeiro2.png" alt="logo_financeiro">
                        <p class="p-icone">Financeiro</p>
                    </button>
                </mat-grid-tile>
                <mat-grid-tile>
                    <button mat-button class="botao-icone" (click)="goToSolicitacoes()">
                        <img class="icone_grade" src="../../../assets/solicitacoes2.png" alt="logo_solicitacoes">
                        <p class="p-icone">Solicitações</p>
                    </button>
                </mat-grid-tile>
                <mat-grid-tile> <!-- class="grid4" classe usada para quando era 5 icones -->
                    <button mat-button class="botao-icone" (click)="goToDocumentos()">
                        <img class="icone_grade" src="../../../assets/documentos2.png" alt="logo_documentos">
                        <p class="p-icone">Documentos</p>
                    </button>
                </mat-grid-tile>
                <!-- <mat-grid-tile>
                    class="grid5" classe usada para quando era 5 icones
                    <button mat-button class="botao-icone" (click)="gotoConteudoDigital()">
                        <img class="icone_grade" src="../../../assets/conteudo.png" alt="logo_conteudo_digital">
                        <p class="p-icone">Conteúdo</p>
                    </button>
                </mat-grid-tile> -->
                <mat-grid-tile> class="grid6" classe usada para quando era 5 icones
                    <button mat-button class="botao-icone" (click)="goToEja()">
                        <img class="icone_grade" src="../../../assets/eja_encceja2.png" alt="logo_eja_encceja">
                        <p class="p-icone">{{ cursoEjaEnccejaEAD }}</p>
                    </button>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="cursoEjaEnccejaEAD != 'EAD'">
                    <a href="https://www.youtube.com/c/SupletivoPreparat%C3%B3rio" target="_blank">
                        <button mat-button class="botao-icone">
                            <img class="icone_grade" src="../../../assets/youtube2.png" alt="logo_youtube">
                            <p class="p-icone">YouTube</p>
                        </button>
                    </a>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="cursoEjaEnccejaEAD != 'EAD'">
                    <a href="https://t.me/supletivopreparatorioejaencceja" target="_blank">
                        <button mat-button class="botao-icone">
                            <img class="icone_grade" src="../../../assets/telegram2.png" alt="logo_telegram">
                            <p class="p-icone">Telegram</p>
                        </button>
                    </a>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="cursoEjaEnccejaEAD == 'EAD'">
                    <a href="https://www.youtube.com/channel/UCfgpZT7ibTWvyGNTnWTheBw" target="_blank">
                        <button mat-button class="botao-icone">
                            <img class="icone_grade" src="../../../assets/youtube2.png" alt="logo_youtube">
                            <p class="p-icone">YouTube</p>
                        </button>
                    </a>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="cursoEjaEnccejaEAD == 'EAD'">
                    <a href="https://t.me/cursosnacionaltec" target="_blank">
                        <button mat-button class="botao-icone">
                            <img class="icone_grade" src="../../../assets/telegram2.png" alt="logo_telegram">
                            <p class="p-icone">Telegram</p>
                        </button>
                    </a>
                </mat-grid-tile>
            </mat-grid-list>
        </div>
    </div>
</div>